import { Menu } from '@/shared/ui/Header/MenuButton/index'
import { Header } from '@/shared/ui/Header/index'
import { Stepper } from '@/shared/ui/Stepper/index'
import { Text } from '@/shared/ui/Typography'
import { Container, ContentBox } from '@/shared/ui/layouts/AppLayout/styles'
import Image from 'next/image'
import { type ReactNode, useState } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import flashLogoImg from 'public/assets/images/flash-logo-footer.svg'

export type LayoutProps = {
  children: ReactNode
  steps: string[]
  currentStep: number
}

export function AppLayout({ children, steps, currentStep }: LayoutProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const matchesSm = useMediaQuery('(max-width: 767px)', {
    initializeWithValue: false,
  })

  function handleMenuToggle() {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <Header
        steps={steps}
        currentStep={currentStep}
        isMenuOpen={isMenuOpen}
        onMenuToggle={handleMenuToggle}
      />
      <Container isMenuOpen={isMenuOpen}>
        <ContentBox>{children}</ContentBox>
        {matchesSm ? (
          <footer>
            <Text size="caption1">Realizado por</Text>
            <Image src={flashLogoImg} alt="Flash" width={44} quality={100} />
          </footer>
        ) : null}
      </Container>
      {!!steps.length && (
        <Menu isOpen={isMenuOpen}>
          <Stepper
            variant="dotted"
            direction="vertical"
            steps={steps}
            currentStep={currentStep}
            isMenuOpen={isMenuOpen}
          />
        </Menu>
      )}
    </>
  )
}
